export default function CTASection() {
  return (
    <section className="relative py-24 overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/0ceab0fa7c86ac262f619f89ab34680b.jpg"
        alt="American neighborhood with backup power protection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/65 to-black/75"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/40 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-6 uppercase tracking-widest">
          <i className="ri-timer-flash-line"></i>
          Don&apos;t Wait for the Next Outage
        </div>

        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 leading-tight">
          Prepare Before the Next<br />
          <span className="text-amber-400">Storm Takes the Grid Down</span>
        </h2>
        <p className="text-gray-200 text-lg mb-3 max-w-xl mx-auto leading-relaxed">
          The families who stay warm, connected, and fed during outages are the ones who prepared ahead of time — not the ones who waited.
        </p>
        <p className="text-amber-300 font-semibold text-base mb-10 max-w-xl mx-auto">
          Shop home backup power systems, solar generators, and off-grid solutions built for real life.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://ironhavensupply.com/collections/home-backup-power"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amber-500 hover:bg-amber-400 text-white font-bold px-10 py-4 rounded-md text-base transition-colors cursor-pointer whitespace-nowrap"
          >
            Shop Power Systems
          </a>
          <a
            href="/about"
            className="border border-white/50 hover:border-white text-white font-semibold px-10 py-4 rounded-md text-base transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-information-line"></i>
            </div>
            About Iron Haven
          </a>
        </div>

        {/* Trust strip */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/60 text-xs">
          {["Free At-Home Delivery", "Premium U.S. Brands", "Manufacturer Warranties", "Real Customer Support"].map((t) => (
            <div key={t} className="flex items-center gap-1.5 whitespace-nowrap">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-amber-400 text-xs"></i>
              </div>
              <span>{t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
